import Auth from "./auth";
import isLoading from "./isLoading";
import ACTIVE_MENU from "./activeMenu";
import AUTH_TOKEN from "./authToken";
import { combineReducers } from "redux"

const rootReducer = combineReducers({
    Auth:Auth,
    IsLoading:isLoading,
    ActiveMenu: ACTIVE_MENU,
    AuthToken: AUTH_TOKEN
});

export default rootReducer;